export function validateFtfc(data) {
  const { timeFrames, tradePlan } = data;
  if (!timeFrames || timeFrames?.length === 0)
    return [false, 'You must add at least one time frame to FTFC.'];
  if (tradePlan.entryTactics?.CANDLE_BREAK) {
    if (tradePlan.entryTactics?.CANDLE_BREAK?.waitUntilCurrentCandleCloses) {
      return [
        false,
        'You cannot select Wait for Candle Close in Candle Break entry when using FTFC.',
      ];
    }
  }
  const arrayIsNotValid = timeFrames.some((obj) => {
    if (obj.candleDuration <= 0 || !obj.timeUnit || obj.timeUnit === '')
      return true;
    else return false;
  });
  if (arrayIsNotValid)
    return [
      false,
      'Each time frame must have a valid time unit and a candle duration larger than 0',
    ];
  return [true, ''];
}
